/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import { Helmet } from "react-helmet";

import { useEnvs } from "state/EnvironmentsContext/EnvContext";

const appendMetaTitle = (title, meta_title) => {
  const hasMetaTitle =
    title.toLowerCase().includes(meta_title) || title.includes(" | ");

  if (hasMetaTitle) return title;
  return `${title} | ${meta_title}`;
};

const MetaTitle = ({ title, description = "" }) => {
  const { meta_title } = useEnvs();
  const appendedTitle = appendMetaTitle(title, meta_title);
  return (
    <Helmet test-id="zssUGp8P">
      <title test-id="pNfW8MEt">{appendedTitle}</title>
      {description && (
        <meta name="description" content={description} test-id="_H3S1d-I" />
      )}
    </Helmet>
  );
};

export default MetaTitle;
